import React, { createContext, FC, useContext } from 'react'
import {
  trackConversionContextInitialState,
  useTrackConversionContextState,
} from './hooks/useTrackConversionContextState'

export const TrackConversionContext = createContext<
  ReturnType<typeof useTrackConversionContextState>
>(trackConversionContextInitialState)

export const TrackConversionProvider: FC = ({ children }) => {
  const state = useTrackConversionContextState()
  return <TrackConversionContext.Provider value={state}>{children}</TrackConversionContext.Provider>
}

export const useTrackConversionContext = () => useContext(TrackConversionContext)
